import { NotificationsState } from './types';

export default function createState(): NotificationsState {
  return {
    notifications: [],
    maxNotifications: 5, // Max visible at once
    defaultDuration: 5000, // 5 seconds default
  };
}

